import React, { useEffect, useState } from "react";
import Pagination from "@mui/material/Pagination";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import IconButton from '@mui/material/IconButton';

import Typography from "../../../../Typography";
import FieldContainer from "../../../../FieldContainer/FieldContainer";

import { getDealHistoric } from "../../../../../services/nps/functions";

import { ReactComponent as CloseIcon } from "../../../../../build/images/close-circle.svg";
import { ReactComponent as ArrowBackIcon } from "../../../../../build/images/arrow_back.svg";
import { ReactComponent as ChevronLeftIcon } from "../../../../../build/images/nps-dashboard-icons/chevron-left.svg";
import { ReactComponent as ChevronRightIcon } from "../../../../../build/images/nps-dashboard-icons/chevron-right.svg";

import "./user-history.css";

export default function UserHistory({
    userHistoryDrawer,
    onCloseDrawer,
    treatmentData,
    onSearch,
    interactionPhone
}) {
    const itemsPerPageOptions = [5, 10, 20];
    const [userHistory, setUserHistory] = useState([]);
    const [itemsPerPage, setItemsPerPage] = useState(itemsPerPageOptions[0]);
    const [currentPage, setCurrentPage] = useState(1);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = userHistory.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(event.target.value);
        setCurrentPage(1); // Reset to first page when changing items per page
    };

    function getBackgroundColor(npsNote) {
        if (npsNote >= 0 && npsNote <= 6) {
            return "#c90000";
        } else if (npsNote === 7 || npsNote === 8) {
            return "#F2BD00";
        } else if (npsNote === 9 || npsNote === 10) {
            return "#008908";
        } else {
            return "#c90000";
        }
    };

    function formatPhoneNumber(phoneNumber) {
        if (!phoneNumber) return "";

        const ddd = phoneNumber.substring(0, 2);
        const number = phoneNumber.substring(2);

        return `(${ddd}) ${number}`;
    };

    useEffect(() => {
        const fetchData = async () => {
            const response = await getDealHistoric(onSearch ? interactionPhone : treatmentData.numero_cliente);

            if (response.status !== 200) return;

            if (response.status === 200) setUserHistory(response.data)
        }

        fetchData();
    }, []);

    return (
        <div className={`user-history-container ${userHistoryDrawer ? '' : 'closed'}`}>
            <header className="user-history-container__header">
                <div>
                    <ArrowBackIcon
                        onClick={onCloseDrawer}
                    />

                    <Typography.H1 color="blue-selected-4" weight={700}>
                        Histórico do usuário
                    </Typography.H1>
                </div>

                <button
                    className="user-history-container__header__close"
                    onClick={onCloseDrawer}
                >
                    <CloseIcon />
                </button>
            </header>

            <main className="user-history-container__content">
                <section className="user-history-section1">
                    <div className="user-history-section1__content">
                        <div
                            className="user-history-section1__content__number"
                            style={{ backgroundColor: getBackgroundColor(treatmentData.nota_nps || treatmentData.note) }}
                        >
                            <Typography.H1 weight="700" color="white">
                                {treatmentData.nota_nps || treatmentData.note}
                            </Typography.H1>
                        </div>

                        <div className="user-history-section1__content__phone-and-user">
                            <Typography.H2 weight="700" color="gray-180">
                                {treatmentData.nome_cliente || treatmentData.clientname}
                            </Typography.H2>

                            <Typography.H5 weight="400" color="gray-180">
                                {formatPhoneNumber(treatmentData.numero_cliente || treatmentData.phone)}
                            </Typography.H5>
                        </div>
                    </div>
                </section>

                <section className="user-history-section2">
                    <Typography.H5 weight="500" color="gray-180">
                        Dados do atendimento
                    </Typography.H5>

                    <div className="user-history-section2__cards">
                        {currentItems.map((card, index) => (
                            <div key={index} className="card-content">
                                <FieldContainer className="card-content__field-container" title="Data e hora">
                                    <Typography.H5 weight="500" color="gray-180">
                                        {card.data_atendimento}
                                    </Typography.H5>
                                </FieldContainer>
                                <FieldContainer className="card-content__field-container" title="Unidade">
                                    <Typography.H5 weight="500" color="gray-180">
                                        {card.unidade}
                                    </Typography.H5>
                                </FieldContainer>
                                <FieldContainer className="card-content__field-container" title="Nota">
                                    <Typography.H5 weight="500" color="gray-180">
                                        {card.nota_nps}
                                    </Typography.H5>
                                </FieldContainer>
                                <FieldContainer className="card-content__field-container" title="NPS">
                                    <Typography.H5 weight="500" color="gray-180">
                                        {
                                            card.nota_nps >= 0 && card.nota_nps <= 6 ?
                                                "Detrator" : card.nota_nps === 7 ||
                                                    card.nota_nps === 8 ? "Neutro" : "Promotor"
                                        }
                                    </Typography.H5>
                                </FieldContainer>
                                <FieldContainer className="card-content__field-container" title="Ordem de serviço">
                                    <Typography.H5 weight="500" color="gray-180">
                                        {card.protocolo}
                                    </Typography.H5>
                                </FieldContainer>
                                <FieldContainer className="card-content__field-container" title="Atendente">
                                    <Typography.H5 weight="500" color="gray-180">
                                        {card.atendente}
                                    </Typography.H5>
                                </FieldContainer>
                                <FieldContainer className="card-content__field-container" title="Convênio">
                                    <Typography.H5 weight="500" color="gray-180">
                                        {card.plano}
                                    </Typography.H5>
                                </FieldContainer>
                            </div>
                        ))}

                        <div className="user-history-section2__cards__pagination-container">
                            <Typography.H5 weight="500" color="gray-180">Linha por página:</Typography.H5>
                            <Select
                                value={itemsPerPage}
                                onChange={handleItemsPerPageChange}
                                variant="standard"
                                className="pagination-select"
                            >
                                {itemsPerPageOptions.map((option) => (
                                    <MenuItem key={option} value={option}>
                                        {option}
                                    </MenuItem>
                                ))}
                            </Select>

                            <Typography.H5 weight="500" color="gray-180">
                                Mostrando {indexOfFirstItem + 1}-{Math.min(indexOfLastItem, userHistory.length)} de {userHistory.length} itens
                            </Typography.H5>

                            <Pagination
                                count={1}
                                page={currentPage}
                                onChange={handlePageChange}
                                renderItem={(item) => {
                                    switch (item.type) {
                                        case 'previous':
                                            return (
                                                <IconButton
                                                    onClick={() => handlePageChange(null, currentPage - 1)}
                                                    disabled={currentPage === 1}
                                                    className="icon-buttom"
                                                >
                                                    <ChevronLeftIcon />
                                                </IconButton>
                                            );
                                        case 'next':
                                            return (
                                                <IconButton
                                                    onClick={() => handlePageChange(null, currentPage + 1)}
                                                    disabled={currentPage === Math.ceil(userHistory.length / itemsPerPage)}
                                                    className="icon-buttom"
                                                >
                                                    <ChevronRightIcon />
                                                </IconButton>
                                            );
                                        default:
                                            return null;
                                    }
                                }}
                                className="pagination"
                            />

                            {/* <Pagination
                                count={Math.ceil(cardContentData.length / itemsPerPage)}
                                page={currentPage}
                                onChange={handlePageChange}
                                variant="outlined"
                                shape="rounded"
                                className="pagination"
                            /> */}
                        </div>
                    </div>
                </section>
            </main>
        </div>
    )
}
